import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Features from '../components/Features/Features';
import Footer from '../components/Footer/Footer';
import styles from './Home.module.css';

const Home = () => {
  return (
    <div className={styles.homeContainer}>
      <div className={styles.contentWrapper}>
        <Header />
        <main>
          <Hero />
          <Features />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Home;